import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import UpdateTripDetails from "./UpdateTripDetails";
import AddTripDetails from "./AddTripDetails";
import Pagination from "../../Common/Pagination/Pagination";
import { sweetAlert } from "../../Common/Utills/Utills";
import moment from "moment";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";
const TripDetails = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setSelectedRowsData] = useState({});
  const [rowAddData, setRowAddData] = useState({
    vehicle_id: "",
    driver_id: "",
    company_id: "",
    received_date: "",
    new_tyre_num: "",
    old_tyre_num: "",
    new_start_date: "",
    start_km: "",
    current_km: "",
    running_km: "",
    tyre_brand: "",
    quality_status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const formRef = useRef(null);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [selectVehicleId, setSelectVehicleId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: "",
    start_date: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => {
      return {
        ...prevFilterCriteria,
        [name]: value,
      };
    });
  };

  function resetFileds() {
    setRowAddData("");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setSelectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleDateChange = (name, date) => {
    const formattedDate = date
      ? moment(date).format("YYYY-MM-DD hh:mm:ss A")
      : "";
    setSelectedRowsData({ ...selectedRowsData, [name]: formattedDate });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { vehicle_number } = rowAddData;

    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        vehicle_number,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        resetFileds();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    let BASE_URL = SERVER_URL + `/api/trips/all-trips/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setRowData(result.data);
      setTotalRecords(result.total);
      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      getData();
      setLoadingOverlayVisible(true);
    }
    check = false;
  }, []);

  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteRow = async (id) => {
    // setRowData((prevData) => prevData.filter((row) => row !== rowData));

    const message = "Do you want to delete this battery details!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }

    let BASE_URL = SERVER_URL + `/api/trips/trips/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setSelectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const {
      id,
      company_id,
      vehicle_id,
      driver_id,
      battery_num,
      battery_brand,
      specification,
      warrenty_guarantee,
      start_date,
    } = rowData;
    let BASE_URL = SERVER_URL + `/api/battery/battery-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id,
        vehicle_id,
        driver_id,
        battery_num,
        battery_brand,
        specification,
        warrenty_guarantee,
        start_date,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      // getData();
    } else {
      toast.error(response.message);
      // getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Start Point/Location",
      field: "companyDetails.company_name",
      valueFormatter: (params) => {
        const location = params.data.companyDetails.location;
        // const type = params.data.company.type;
        return `${params.value}, ${location}`;
      },
      editable: false,
      minWidth: 250,
    },
    {
      headerName: "Vehicle Number",
      field: "vehicleDetails.vehicle_number",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Start Reading",
      field: "start_reading",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Distance Start - Location",
      field: "dist_start_loc",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Location Reading",
      field: "location_reading",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Distance Location - Return",
      field: "dist_loc_return",
      editable: false,
      minWidth: 220,
    },
    {
      headerName: "Return Reading",
      field: "return_reading",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Return Point/Location",
      field: "return_location",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Total Distance",
      field: "total_distance",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Start Date",
      field: "start_date",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Departure Date Time",
      field: "departure_datetime",
      valueFormatter: (params) => {
        const departureTime = params.value
          ? moment.utc(params.value).format("DD-MM-YYYY hh:mm:ss A")
          : "-";
        // const type = params.data.company.type;
        return departureTime;
      },
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "End Date",
      field: "end_date",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Return Date Time",
      field: "return_datetime",
      valueFormatter: (params) => {
        const returnTime = params.value
          ? moment.utc(params.value).format("DD-MM-YYYY hh:mm:ss A")
          : "-";
        // const type = params.data.company.type;
        return returnTime;
      },
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Driver Name",
      field: "driver_name",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Advance Pay",
      field: "advance_pay",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Total Expense",
      field: "total_expense",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Refuel Place",
      field: "refuel_place",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Reading Refuel Place",
      field: "reading_refuel_place",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Diesel (in ltr.)",
      field: "diesel_ltr",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Rate",
      field: "rate",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Amount",
      field: "amount",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Running",
      field: "running",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Average",
      field: "average",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Remarks",
      field: "remarks",
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Trip Status",
      field: "trip_status",
      cellRenderer: (params) => (
        <label
          className={`badge ${
            params.data.trip_status == "ongoing"
              ? "badge-success"
              : "badge-secondary"
          }`}
          style={{ width: "100px" }}
        >
          {params.data.trip_status == "ongoing" ? "On-going" : "Completed"}
        </label>
      ),
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm ml-1"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#editModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>{" "}
          <NavLink
            className="btn btn-outline-info btn-sm ml-1"
            to={"/trip-dipatch-details/" + params.data.id}
          >
            <i className="mdi mdi-eye-arrow-right-outline" />
          </NavLink>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    setfilterCriteria({
      company_id: "",
      start_date: "",
      vehicle_id: "",
    });
    setSelectedCompanyId("");
    setSelectVehicleId("");
    getData();
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyFilterChange = (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const handleFilterVehicleChange = (e) => {
    const vehicleId = e.target.value ? parseInt(e.target.value) : "";
    setSelectVehicleId(vehicleId);
    setfilterCriteria((preventDefault) => ({
      ...preventDefault,
      vehicle_id: vehicleId,
    }));
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Trip Details Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Trip Details
              </button>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div>
            <div
              className="search mb-3"
              style={{
                transition: "background-color 0.3s", // Smooth transition
                paddingTop: "10px 20px",
              }}
            >
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control form-control-lg"
                      onChange={handleCompanyFilterChange}
                      value={selectedCompanyId}
                    >
                      <option value="">Select Company (All)</option>
                      {company &&
                        company?.length > 0 &&
                        company?.map((item, id) => {
                          return (
                            <React.Fragment key={id}>
                              <option
                                value={item.id}
                                key={id}
                              >{`${item.company_name}, ${item.location}`}</option>
                            </React.Fragment>
                          );
                        })}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control form-control-lg"
                      onChange={handleFilterVehicleChange}
                      value={selectVehicleId}
                      id="material_name"
                      required
                    >
                      <option value="">Select Vehicle</option>
                      {vehicle &&
                        vehicle?.length > 0 &&
                        vehicle?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.vehicle_number}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
                <div className="col-md-3" style={{ display: "flex" }}>
                  <input
                    type="date"
                    className="form-control"
                    value={filterCriteria.start_date}
                    onChange={(e) =>
                      handleFilterChange("start_date", e.target.value)
                    }
                    min={minDate}
                  />
                </div>
              </div>
            </div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                context={{ currentPage, pageSize }}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>

          <AddTripDetails
            getData={getData}
            handleAddDataSubmit={handleAddDataSubmit}
            formRef={formRef}
            setSelectedRowsData={setSelectedRowsData}
          />
          <UpdateTripDetails
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            handleDateChange={handleDateChange}
            getData={getData}
            setSelectedRowsData={setSelectedRowsData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default TripDetails;
